@if (loading()) {
<app-page-loader loadingType="content" />
} @else {
<div class="p-3 h-[calc(100%-var(--spacing)*15)]">
  <app-breadcrumb [items]="[{ label: 'Translations', route: '/translations' },{ label: 'Export' }]"/>
  <div class="h-[calc(100%-var(--spacing)*9)] rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
    <div class="h-full w-full overflow-y-scroll">

      @if (canEdit()) {
      <!-- Toolbar -->
      <div class="sticky flex flex-wrap items-end gap-3 top-0 left-0 bg-white border-b border-stroke px-5 py-4 dark:border-strokedark sm:px-7.5">
        <div class="flex-1 min-w-48">
          <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Select Survey</label>
          <select
            [(ngModel)]="selectedSurveyId"
            class="h-9 rounded-lg border border-gray-300 bg-blue-50 px-3 text-sm text-gray-800 shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white"
          >
            <option value="" disabled>Select survey</option>
            @for (survey of surveyList; track survey.id) {
              <option [value]="survey.id">{{ survey.name }}</option>
            }
          </select>
        </div>

        <button type="button" (click)="requestExport('CSV')"
          [disabled]="!selectedSurveyId || requesting()"
          class="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
          @if (requesting()) {
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
            Requesting...
          } @else {
            Export CSV
          }
        </button>

        <button type="button" (click)="requestExport('Excel')"
          [disabled]="!selectedSurveyId || requesting()"
          class="flex items-center gap-2 rounded-lg border border-green-600 bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed">
          @if (requesting()) {
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
            Requesting...
          } @else {
            Export Excel
          }
        </button>
      </div>
      }
      @if (error()) {
      <div class="text-left p-3">
        <p class="rounded-lg border border-red-200 p-3 text-sm text-red-600 bg-red-100">{{ error() }}</p>
      </div>
      }

      <!-- History table -->
      <div class="p-5">
        <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
          <div class="flex items-center gap-2">
            <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-200">Export History</h3>
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <label class="text-xs text-gray-500 dark:text-gray-400">Filter by survey</label>
            <select
              [(ngModel)]="historyFilterSurveyId"
              (change)="onHistoryFilterChange()"
              class="h-8 rounded-lg border border-gray-300 bg-white px-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white"
            >
              <option value="">All surveys</option>
              @for (survey of surveyList; track survey.id) {
                <option [value]="survey.id">{{ survey.name }}</option>
              }
            </select>
            <label class="text-xs text-gray-500 dark:text-gray-400">Per page</label>
            <select
              [(ngModel)]="historyPerPage"
              (change)="onPerPageChange()"
              class="h-8 rounded-lg border border-gray-300 bg-white px-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white"
            >
              @for (opt of perPageOptions; track opt) {
                <option [ngValue]="opt">{{ opt }}</option>
              }
            </select>
            <button type="button" (click)="loadAllHistory()"
              [disabled]="loadingHistory()"
              title="Refresh"
              class="flex items-center justify-center h-8 w-8 rounded-lg border border-gray-300 bg-white text-gray-500 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:bg-gray-900 dark:hover:bg-gray-800">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" [class.animate-spin]="loadingHistory()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
              </svg>
            </button>
          </div>
        </div>

        @if (loadingHistory()) {
          <div class="flex justify-center py-10">
            <svg class="h-6 w-6 animate-spin text-blue-500" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
          </div>
        } @else if (historyItems().length === 0) {
          <p class="py-10 text-center text-sm text-gray-400">No export history found.</p>
        } @else {
          <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
            <table class="w-full text-sm text-left text-gray-700 dark:text-gray-300">
              <thead class="bg-gray-50 text-xs text-gray-500 uppercase dark:bg-gray-800 dark:text-gray-400">
                <tr>
                  <th class="pl-5 pr-4 py-3 max-w-24">Export ID</th>
                  <th class="px-4 py-3">Survey</th>
                  <th class="px-4 py-3">Format</th>
                  <th class="px-4 py-3">Status</th>
                  <th class="px-4 py-3">Created</th>
                  <th class="px-4 py-3">Updated</th>
                  <th class="px-4 py-3">Download</th>
                </tr>
              </thead>
              <tbody>
                @for (item of historyItems(); track item.id) {
                <tr class="border-t border-gray-100 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-800">
                  <td class="pl-5 pr-4 py-3 max-w-24">
                    <button type="button" (click)="copyToClipboard(item.id)"
                      class="group relative font-mono text-xs text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
                      [title]="item.id">
                      @if (copiedText() === item.id) {
                        <span class="flex items-center gap-1.5 text-green-500">
                          <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                          Copied!
                        </span>
                      } @else {
                        <svg class="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                        </svg>
                        <span class="inline-block max-w-24 truncate">{{ item.id }}</span>
                      }
                    </button>
                  </td>
                  <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400" [title]="item.surveyId">
                    {{ getSurveyName(item.surveyId) }}
                  </td>
                  <td class="px-4 py-3">
                    <span class="rounded px-2 py-0.5 text-xs font-medium"
                      [class.bg-blue-100]="item.format === 'CSV'"
                      [class.text-blue-700]="item.format === 'CSV'"
                      [class.bg-green-100]="item.format === 'Excel'"
                      [class.text-green-700]="item.format === 'Excel'">
                      {{ item.format }}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <span class="rounded px-2 py-0.5 text-xs font-medium"
                      [class.bg-gray-100]="item.status === 'created'"
                      [class.text-gray-600]="item.status === 'created'"
                      [class.bg-green-100]="item.status === 'completed'"
                      [class.text-green-700]="item.status === 'completed'"
                      [class.bg-red-100]="item.status === 'error'"
                      [class.text-red-700]="item.status === 'error'"
                      [title]="item.errorDescription ?? ''">
                      {{ item.status }}
                    </span>
                  </td>
                  <td class="px-4 py-3 text-xs">{{ item.createdDate | date:'yyyy-MM-dd HH:mm' }}</td>
                  <td class="px-4 py-3 text-xs">{{ item.updatedDate ? (item.updatedDate | date:'yyyy-MM-dd HH:mm') : '—' }}</td>
                  <td class="px-4 py-3">
                    @if (item.downloadUrl) {
                      <a [href]="item.downloadUrl" target="_blank"
                        class="text-blue-600 hover:underline text-xs font-medium">
                        Download
                      </a>
                    } @else {
                      <span class="text-gray-300 text-xs">—</span>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="mt-4 flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
            <span>{{ totalCount() }} result{{ totalCount() === 1 ? '' : 's' }} &mdash; page {{ currentPage() }} of {{ totalPages }}</span>
            <div class="flex gap-1">
              <button type="button" (click)="changePage(currentPage() - 1)"
                [disabled]="currentPage() === 1"
                class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:hover:bg-gray-800">
                Prev
              </button>
              <button type="button" (click)="changePage(currentPage() + 1)"
                [disabled]="currentPage() === totalPages"
                class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:hover:bg-gray-800">
                Next
              </button>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</div>
}
